import * as AuthActions from './auth.actions';
import {Cookie} from '../../helper/cookie';
import {environment} from '../../../environments/environment';

const cookie = new Cookie();

export interface State {
  token: string;
  exp: number;
  authenticated: boolean;
  userId: number;
}

const initialState: State = {
  token: cookie.getCookie('auditor-token'),
  exp: cookie.getCookie('auditor-token-expiry') ? + cookie.getCookie('auditor-token-expiry') : null,
  authenticated: null,
  userId: cookie.getCookie('auditor-user-id') ? + cookie.getCookie('auditor-user-id') : null
};

export function authReducer(state = initialState, action: AuthActions.AuthActions) {
  switch (action.type) {
    case (AuthActions.SET_TOKEN):
      cookie.setCookie('auditor-token', action.payload.token, new Date(action.payload.exp * 1000), '/', environment.cookiesHost);
      cookie.setCookie('auditor-token-expiry', action.payload.exp.toString(), new Date(action.payload.exp * 1000), '/', environment.cookiesHost);
      cookie.setCookie('auditor-user-id', action.payload.id.toString(), new Date(action.payload.exp * 1000), '/', environment.cookiesHost);
      return {
        ...state,
        token: action.payload.token,
        exp: action.payload.exp,
        userId: action.payload.id
      };
    case (AuthActions.SIGNIN):
    case (AuthActions.SIGNUP):
      return {
        ...state,
        authenticated: true
      };
    case (AuthActions.LOGOUT):
      cookie.removeCookie('auditor-token');
      cookie.removeCookie('auditor-token-expiry');
      cookie.removeCookie('auditor-user-id');
      return {
        ...state,
        token: null,
        exp: null,
        userId: null
      };
  }
  return state;
}